import { ReduxService } from 'dashboard-services/services';

import { basicAITransformerActions } from 'actions/modules/aiTools';

export const aiTransformerInitialState = {
  outputPythonCode: undefined // not in common state as output python code is not common case
}

export default (state = aiTransformerInitialState, action) => {
  switch (action.type) {
    case basicAITransformerActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value })
      }
      return state;
    }
    case basicAITransformerActions.CLEAR:
      return aiTransformerInitialState;
    default:
      return state;
  }
}